import React from 'react';
import {
    ensureSeriesPlan,
    isPyramidExercise,
    resizeSeriesPlan,
} from '../../../constants/workoutSeriesPlan';

/**
 * Editor righe Serie 1..N per esercizi piramidali.
 * Visibile solo se set_type === 'piramidale'.
 */
export default function PyramidSeriesEditor({ exercise, onUpdate, showWeight = true, gymDarkInputs = true }) {
    if (!isPyramidExercise(exercise)) {
        return null;
    }

    const plan = ensureSeriesPlan(exercise) || [];
    const inputClass = gymDarkInputs
        ? 'w-full rounded-md border border-[#dad8e5] bg-white px-3 py-2 text-[#3a3a3a] focus:border-[#372d83] focus:ring-2 focus:ring-[#372d83]/30 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:focus:border-indigo-500 dark:focus:ring-indigo-500/30'
        : 'w-full rounded-md border border-gray-300 px-3 py-2';

    const updatePlan = (newPlan) => {
        onUpdate(exercise.id ?? exercise.tempId, 'series_plan', newPlan);
        if (newPlan.length > 0) {
            onUpdate(exercise.id ?? exercise.tempId, 'ripetizioni', newPlan[0].reps);
        }
    };

    const handleSerieChange = (newSerie) => {
        const serie = Math.max(1, parseInt(newSerie, 10) || 1);
        onUpdate(exercise.id ?? exercise.tempId, 'serie', serie);
        const resized = resizeSeriesPlan(
            plan,
            serie,
            parseInt(exercise.ripetizioni, 10) || 10,
            exercise.peso
        );
        updatePlan(resized);
    };

    const handleRowChange = (index, field, value) => {
        const next = plan.map((row, i) => {
            if (i !== index) return row;
            if (field === 'reps') {
                return { ...row, reps: Math.max(1, parseInt(value, 10) || 1) };
            }
            if (field === 'weight') {
                const w = value === '' ? null : parseFloat(value);
                return { ...row, weight: Number.isFinite(w) ? w : null };
            }
            return row;
        });
        updatePlan(next);
    };

    return (
        <div className="mt-4 rounded-lg border border-blue-200 bg-blue-50/50 p-4 dark:border-blue-800/40 dark:bg-blue-950/20">
            <p className="mb-3 text-sm font-medium text-blue-900 dark:text-blue-200">
                Piano piramidale - reps (e peso opzionale) per ogni serie
            </p>
            <div className="mb-3">
                <label className="mb-1 block text-sm font-medium text-[#3a3a3a] dark:text-white/85">
                    Numero serie
                </label>
                <input
                    type="number"
                    min="1"
                    max="20"
                    value={exercise.serie ?? plan.length}
                    onChange={(e) => handleSerieChange(e.target.value)}
                    className={`${inputClass} max-w-[120px]`}
                />
            </div>
            <div className="space-y-2">
                {plan.map((row, index) => (
                    <div key={row.n} className="grid grid-cols-2 md:grid-cols-4 gap-3 items-end">
                        <div className="text-sm font-medium text-[#3a3a3a] dark:text-white/85 md:col-span-1">
                            Serie {row.n}
                        </div>
                        <div>
                            <label className="mb-1 block text-xs text-[#3a3a3a]/70 dark:text-white/60">
                                Reps
                            </label>
                            <input
                                type="number"
                                min="1"
                                value={row.reps ?? ''}
                                onChange={(e) => handleRowChange(index, 'reps', e.target.value)}
                                className={inputClass}
                            />
                        </div>
                        {showWeight && exercise.is_cardio !== 1 && (
                            <div>
                                <label className="mb-1 block text-xs text-[#3a3a3a]/70 dark:text-white/60">
                                    Peso (kg)
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.5"
                                    value={row.weight ?? ''}
                                    onChange={(e) => handleRowChange(index, 'weight', e.target.value)}
                                    placeholder={exercise.peso ? String(exercise.peso) : '-'}
                                    className={inputClass}
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
